import React from 'react';
import { X, Award, Clock } from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { AVAILABILITY_OPTIONS } from '../register/options';

export const RegisterDoctorAvailability = ({ addToArray, formData, handleChange, newAward, newResearchInterest, removeFromArray, renderTagSelector, setNewAward, setNewResearchInterest }) => (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Clock className="w-5 h-5 text-[hsl(var(--primary))]" />
        Availability & Additional Info
      </h3>

      {renderTagSelector('availability', AVAILABILITY_OPTIONS, 'Available Days')}

      <div>
        <label className="block text-sm font-medium mb-1.5">Consultation Timings</label>
        <input
          name="consultation_timings"
          type="text"
          value={formData.consultation_timings}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="10:00 AM - 1:00 PM, 4:00 PM - 7:00 PM"
        />
      </div>

      <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
        <input
          type="checkbox"
          name="emergency_available"
          checked={formData.emergency_available}
          onChange={handleChange}
          className="w-4 h-4 rounded border-gray-300 text-[hsl(var(--primary))] focus:ring-[hsl(var(--primary))]"
        />
        <div>
          <span className="text-sm font-medium">Available for Emergency Consultations</span>
          <p className="text-xs text-gray-500">You may be contacted for urgent cases outside regular hours</p>
        </div>
      </div>

      {/* Awards */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Award className="w-4 h-4 text-[hsl(var(--primary))]" />
          Awards & Recognition
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            value={newAward}
            onChange={(e) => setNewAward(e.target.value)}
            className="flex-1 px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="Best Doctor Award 2023"
            onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addToArray('awards', newAward, setNewAward))}
          />
          <button
            type="button"
            onClick={() => addToArray('awards', newAward, setNewAward)}
            className="px-4 py-2 bg-[hsl(var(--primary))] text-white rounded-lg hover:opacity-90"
          >
            Add
          </button>
        </div>
        {formData.awards.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {formData.awards.map((award, index) => (
              <Badge
                key={index}
                className="bg-amber-100 text-amber-800 cursor-pointer"
                onClick={() => removeFromArray('awards', index)}
              >
                {award} <X className="w-3 h-3 ml-1" />
              </Badge>
            ))}
          </div>
        )}
      </div>

      {/* Research Interests */}
      <div>
        <label className="block text-sm font-medium mb-2">Research Interests</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={newResearchInterest}
            onChange={(e) => setNewResearchInterest(e.target.value)}
            className="flex-1 px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="Minimally Invasive Surgery"
            onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addToArray('research_interests', newResearchInterest, setNewResearchInterest))}
          />
          <button
            type="button"
            onClick={() => addToArray('research_interests', newResearchInterest, setNewResearchInterest)}
            className="px-4 py-2 bg-[hsl(var(--primary))] text-white rounded-lg hover:opacity-90"
          >
            Add
          </button>
        </div>
        {formData.research_interests.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {formData.research_interests.map((interest, index) => (
              <Badge
                key={index}
                className="bg-blue-100 text-blue-800 cursor-pointer"
                onClick={() => removeFromArray('research_interests', index)}
              >
                {interest} <X className="w-3 h-3 ml-1" />
              </Badge>
            ))}
          </div>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium mb-1.5">About You</label>
        <textarea
          name="about"
          value={formData.about}
          onChange={handleChange}
          rows="4"
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="Tell patients about your experience, approach to care, and what makes you unique..."
        />
      </div>
    </div>
);
